import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import Container, { LeftSection, MiddleSection, RightSection } from './components/Container';
import CheckBox from '../CheckBox/CheckBox';
import Button from './components/Button';
import Icon from './components/Icon';
import Textarea from '../Textarea/Textarea';
import Input from '../Input/Input';
import OrderButton from './components/OrderButton';
import InputContainer from './components/InputContainer';

const Checkout = ({
  allSelected,
  onSelectAll,
  comment,
  onCommentChange,
  orderNo,
  onOrderNumberChange,
  onRemoveSelected,
  disabled,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <LeftSection>
        <CheckBox selected={allSelected} onSelect={() => onSelectAll()}>
          {t('selectAll')}
        </CheckBox>
        <Button onClick={() => onRemoveSelected()}>
          <Icon className="mdi mdi-trash-can-outline" />
          {t('removeSelected')}
        </Button>
      </LeftSection>

      <MiddleSection>
        <Textarea
          minRows={1}
          value={comment}
          onChange={(value) => onCommentChange(value)}
        >
          {t('otherComments')}
        </Textarea>
      </MiddleSection>

      <RightSection>
        <InputContainer>
          <Input
            required={true}
            rounded={false}
            value={orderNo}
            maxLength={35}
            onChange={(value) => onOrderNumberChange(value)}
          >
            {t('orderNo')}
          </Input>
        </InputContainer>
        <OrderButton disabled={disabled} onClick={() => onSubmit()}>
          <Icon className="mdi mdi-email-check-outline" />
          {t('order')}
        </OrderButton>
      </RightSection>
    </Container>
  );
};

Checkout.propTypes = {
  allSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  orderNo: PropTypes.string,
  comment: PropTypes.string,
  onSelectAll: PropTypes.func,
  onRemoveSelected: PropTypes.func,
  onCommentChange: PropTypes.func,
  onOrderNumberChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default Checkout;
